import React, { FC } from 'react';
import MuiListItemIcon, { ListItemIconProps as MuiListItemIconProps } from '@mui/material/ListItemIcon';
import { BpDesignSystem } from '../../types';

export type ListItemIconProps = BpDesignSystem.PropsWithChildren<MuiListItemIconProps & {}>;

export const ListItemIcon: FC<ListItemIconProps> = ({ dataTest, ...props }) => (
  <MuiListItemIcon data-test={dataTest} {...props} />
);
